import api from '..'

const requests = {
    fetchContents: async ({ search, sortKey, sortType, pageSize, pageNo }) => {
        var response = await api.get(`/wellful/Content/`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                pageNo
            }
        })

        return response.data
    },
    fetchContent: async (id) => {
        var response = await api.get(`/wellful/Content/${id}`)
        return response.data
    },
    createContent: async (payload) => {
        var response = await api.post(`/wellful/Content`, payload)
        return response.data
    },
    updateContent: async (payload) => {
        var response = await api.put(`/wellful/Content/${payload.contentId}`, payload)
        return response.data
    },
    updateMenuImage: async (id, payload) => {
        var formData = new FormData()

        formData.append('id', id)

        formData.append('file', payload.file)

        return api.put(`/wellful/Content/${id}/MenuImage`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    updateAudioFile: async (id, duration, payload) => {
        var formData = new FormData()

        formData.append('id', id)
        formData.append('duration', duration)

        formData.append('file', payload.file)

        return api.put(`/wellful/Content/${id}/Audio`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    publish: async () => {
        var response = await api.post(`/wellful/Zutak/publish`, {})
        return response.data
    }
}

export default requests
